/* eslint-disable camelcase */
import isEqual from 'lodash/isEqual'
import { setDeepProperty, getDeepProperty } from '@/helpers/deepObject.js'
import { getTimeframeKey } from './path-helpers'

export const addFetching = (state, requestInfo) => {
  setDeepProperty(state, 'status.fetching', [
    ...getDeepProperty(state, 'status.fetching') || [],
    requestInfo
  ])
}

export const removeFetching = (state, requestInfo) => {
  setDeepProperty(
    state,
    'status.fetching',
    (getDeepProperty(state, 'status.fetching') || [])
      .filter(existing => !isEqual(existing, requestInfo))
  )
}

export const addError = (state, errorRecord) => {
  setDeepProperty(state, 'status.errors', [
    ...getDeepProperty(state, 'status.errors') || [],
    errorRecord
  ])
}

export const removeMatchingErrors = (state, errorRecord) => {
  setDeepProperty(
    state,
    'status.errors',
    (getDeepProperty(state, 'status.errors') || [])
      .filter(existing => !isEqual(existing, errorRecord))
  )
}

export const setPodcastDownloadsTotal = (state, { podcastId, options }, response) => {
  // save response.total to totals
  if (options.timeframe && typeof response.total !== 'undefined') {
    const timeframeKey = getTimeframeKey(options.timeframe)
    const timeframePath = `data.podcasts.${podcastId}.downloads.totals.${timeframeKey}`
    setDeepProperty(state, timeframePath, response.total)
  }
}

export const setPodcastDownloads = (state, { podcastId, options }, response) => {
  // save response.total to totals
  setPodcastDownloadsTotal(state, { podcastId, options }, response)

  // save response.by_interval to intervals
  if (response.by_interval) {
    response.by_interval.forEach(({ interval, downloads_total, downloads_percent }) => {
      const intervalPath = `data.podcasts.${podcastId}.downloads.by_${response.interval}.${interval}`
      setDeepProperty(state, intervalPath, {
        total: downloads_total,
        percent: downloads_percent
      })
    })
  }
}

export const setEpisodeDownloadsTotal = (state, { episodeId, options }, response) => {
  // save response.total to totals
  if (options.timeframe && typeof response.total !== 'undefined') {
    const timeframeKey = getTimeframeKey(options.timeframe)
    const timeframePath = `data.episodes.${episodeId}.downloads.totals.${timeframeKey}`
    setDeepProperty(state, timeframePath, response.total)
  }
}

export const setEpisodeDownloads = (state, { episodeId, options }, response) => {
  // save response.total to totals
  setEpisodeDownloadsTotal(state, { episodeId, options }, response)

  // save response.by_interval to intervals
  if (response.by_interval) {
    response.by_interval.forEach(({ interval, downloads_total, downloads_percent }) => {
      const intervalPath = `data.episodes.${episodeId}.downloads.by_${response.interval}.${interval}`
      setDeepProperty(state, intervalPath, {
        total: downloads_total,
        percent: downloads_percent
      })
    })
  }
}
